module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAWlBMVEUAAADV1dW/v7/GxsbExMTDw8PKysrOzs7JycnIyMjIyMjJycnJycnIyMjLy8vJycnKysrKysrJycnKysrJycnIyMjJycnKysrJycnJycnKysrIyMjJycnKyspOSm6OAAAAHnRSTlMABggJDREdHyElKkJQWGJseZScqMLI0d3e3+Hp6/hc1i3MAAAAT0lEQVQIHQXBgQKBMBQAwGuUFWnx0qL9/2+6gxwtMkCUVAKgJakBREklAHK0yAAAMKz1/L5GcD+W3vVZHxiOCdz2iXUBzG9qD+h+fABslz8SfQNjJI+oRAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/commpany_people.png
// module id = nCEq
// module chunks = 2